(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wv-bento"] && !Shopify.designMode) return;
  try {
    
  // Revela la sección una sola vez cuando entra en el viewport. Sin listeners de scroll.
  (function wvBentoInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wvBentoInit);
      return;
    }
    var nodes = document.querySelectorAll('[data-wv-reveal]');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    nodes.forEach(function (n) { io.observe(n); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wv-hero"] && !Shopify.designMode) return;
  try {
    
  // Parallax de puntero, solo escritorio con hover real y sin reduced-motion.
  // Escribe dos custom properties por frame; cada sticker las multiplica por su profundidad.
  (function wvHeroInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wvHeroInit);
      return;
    }
    var mq = window.matchMedia('(hover: hover) and (min-width: 750px) and (prefers-reduced-motion: no-preference)');
    if (!mq.matches) return;
    document.querySelectorAll('[data-wv-sb]').forEach(function (hero) {
      var raf = 0, tx = 0, ty = 0;
      function paint() {
        raf = 0;
        hero.style.setProperty('--wv-px', tx.toFixed(2));
        hero.style.setProperty('--wv-py', ty.toFixed(2));
      }
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        tx = ((e.clientX - r.left) / r.width - 0.5) * -18;
        ty = ((e.clientY - r.top) / r.height - 0.5) * -12;
        if (!raf) raf = requestAnimationFrame(paint);
      }, { passive: true });
      hero.addEventListener('pointerleave', function () {
        tx = 0; ty = 0;
        if (!raf) raf = requestAnimationFrame(paint);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wv-manifesto"] && !Shopify.designMode) return;
  try {
    
  // Mismo observador que el bento: se marca `is-in` una vez al entrar en pantalla.
  (function wvManifestoInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wvManifestoInit);
      return;
    }
    var nodes = document.querySelectorAll('.wv-mf[data-wv-reveal]');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    nodes.forEach(function (n) { io.observe(n); });
  })();

  } catch(e) { console.error(e); }
})();
})();
